import { STATUSPAGE, MainButton, MetadataInfoFooter } from '@repo/ui';
import { EntityType } from 'domain/value-objects/entities-type';
import { getEntityTypeLabel } from 'domain/value-objects/entity-type';
import FeatherIcon from 'feather-icons-react';
import { useEntities } from 'presentation/app/modules/Entities/hooks/useEntities';
import { useEffect, useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { Form, Card, Button, CardBody, CardFooter } from 'reactstrap';
import * as Yup from 'yup';

import { RegisterDataForm } from '../../../form/register-data-form';

interface IProps {
  controller: ReturnType<typeof useEntities>;
}

export const UpdateOrganizationData = ({ controller }: IProps) => {
  // State
  const [modalDeleteState, setModalDeleteState] = useState<boolean>(false);

  // Hooks
  const { entityId } = useParams();

  const navigate = useNavigate();
  const marginYButton = 'my-1';

  const {
    searchByCnpjData,
    statusEditEntities,
    loadingSearchByCnpj,
    statusCreateEntities,
    responseEntitiesById,
    hasChangedAddressFields,
    citiesForSelectOptionsData,
    validationFormRegistrationData,
    requestSearchByCnpj,
    requestEntitiesDelete,
    requestGetAddressViaZipCode,
    setCitiesForSelectOptionsData,
    requestGetAllInsuranceCompanies,
    requestGetAllCitiesForSelectOptions,
    setInternshipLocationPhotoImagePreviewSrc,
    statusDeleteEntities,
    loadingStates,
  } = controller;

  const isLoadingEntityData =
    !!entityId && loadingStates?.getByIdEntities === STATUSPAGE.LOADING;

  const options = [
    {
      label: getEntityTypeLabel(EntityType.Institution),
      value: EntityType.Institution,
    },
    {
      label: getEntityTypeLabel(EntityType.PublicAgency),
      value: EntityType.PublicAgency,
    },
    {
      label: getEntityTypeLabel(EntityType.Company),
      value: EntityType.Company,
    },
  ];

  const zipCodeSchema = Yup.string()
    .zipCodeType('CEP inválido')
    .required('Campo é obrigatório');

  useEffect(() => {
    if (responseEntitiesById) {
      setInternshipLocationPhotoImagePreviewSrc(responseEntitiesById?.photo);
    }
  }, [responseEntitiesById]);

  useEffect(() => {
    requestGetAllInsuranceCompanies();
  }, []);

  const [searchParams] = useSearchParams();
  const activeTabId = searchParams.get('painel');

  return (
    <div className="mt-5">
      {activeTabId ? null : (
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4 className="fw-bold">
              {entityId ? 'Editar Organização' : 'Criar Organização'}
            </h4>
          </div>
        </div>
      )}

      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validationFormRegistrationData.handleSubmit();
          return false;
        }}
      >
        <Card className="mb-1">
          <CardBody>
            <RegisterDataForm
              loading={isLoadingEntityData}
              options={options}
              entityId={entityId}
              marginYButton={marginYButton}
              zipCodeSchema={zipCodeSchema}
              modalDeleteState={modalDeleteState}
              searchByCnpjData={searchByCnpjData}
              loadingSearchByCnpj={loadingSearchByCnpj}
              setModalDeleteState={setModalDeleteState}
              requestSearchByCnpj={requestSearchByCnpj}
              validation={validationFormRegistrationData}
              requestEntitiesDelete={requestEntitiesDelete}
              hasChangedAddressFields={hasChangedAddressFields}
              citiesForSelectOptionsData={citiesForSelectOptionsData}
              requestGetAddressViaZipCode={requestGetAddressViaZipCode}
              setCitiesForSelectOptionsData={setCitiesForSelectOptionsData}
              requestGetAllCitiesForSelectOptions={
                requestGetAllCitiesForSelectOptions
              }
              loadingArchive={statusDeleteEntities === STATUSPAGE.LOADING}
            />
          </CardBody>

          <CardFooter>
            <div
              style={{
                justifyContent: 'space-between',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <div>
                {activeTabId === 'registrationData' && (
                  <MainButton
                    color="danger"
                    onClick={() => {
                      setModalDeleteState(true);
                    }}
                  >
                    Arquivar
                    <FeatherIcon icon={'archive'} size={15} />
                  </MainButton>
                )}
              </div>

              <div className="d-flex">
                <Button
                  color="link"
                  className="btn-link text-decoration-underline"
                  onClick={() => navigate('/organizacoes')}
                >
                  Cancelar
                </Button>
                <MainButton
                  type="submit"
                  isDisabled={
                    statusCreateEntities === STATUSPAGE.LOADING ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                  isLoading={
                    !!statusCreateEntities ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                >
                  Salvar
                </MainButton>
              </div>
            </div>
          </CardFooter>
        </Card>
        <div className="py-2 pb-3">
          <MetadataInfoFooter
            metadata={{
              createdAt: responseEntitiesById?.createdAt,
              lastUpdater: responseEntitiesById?.updaterName,
              updatedAt: responseEntitiesById?.updatedAt,
            }}
          />
        </div>
      </Form>
    </div>
  );
};
